module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/AIR_ELEMENTAL_STYLE.7f3b6474.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/AIR_ELEMENTAL_STYLE.png
// module id = 1262
// module chunks = 16